import api from './client'

export async function getTree(project: string, path: string = '', root: string = 'src') {
  const res = await api.get('/srceditor/tree', { params: { project, path, root } })
  return res.data
}

export async function getFileContent(project: string, path: string, root: string = 'src') {
  const res = await api.get('/srceditor/file/content', { params: { project, path, root } })
  return res.data
}

export async function saveFile(project: string, path: string, content: string, root: string = 'src') {
  const res = await api.post('/srceditor/file/save', { project, path, content, root })
  return res.data
}

export async function deleteFile(project: string, path: string, root: string = 'src') {
  const res = await api.post('/srceditor/file/delete', { project, path, root })
  return res.data
}

export async function aiSuggest(data: {
  project: string
  userInput: string
  selectedText?: string
  fileType?: string
  chatHistory?: Array<{ role: string; content: string }>
  model?: string
  filePath?: string
  attachments?: import('@/lib/attachments').WireAttachment[]
}) {
  const res = await api.post('/srceditor/ai/suggest', data)
  return res.data
}

export async function downloadFile(project: string, path: string, root: string = 'src'): Promise<void> {
  const res = await api.get('/srceditor/file/download', {
    params: { project, path, root },
    responseType: 'blob',
  })
  const filename = path.split('/').pop() || 'download'
  const blob = new Blob([res.data])
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

export async function downloadAll(project: string): Promise<void> {
  const res = await api.get('/srceditor/download-all', {
    params: { project },
    responseType: 'blob',
  })
  const blob = new Blob([res.data], { type: 'application/zip' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `${project}_source.zip`
  a.click()
  URL.revokeObjectURL(url)
}
